/* Benim Eşarpcım — sepet canlı güncelleme
 * cart.js'in yayınladığı cartUpdate olayını dinler; sipariş özeti sunucu
 * tarafından yeniden render edildiği için burada yalnızca özet dışında
 * kalan alanlar (başlık sayacı, ücretsiz kargo barı, header rozeti)
 * anlık güncellenir. */
(function () {
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} TL';
    var value = (Math.max(0, cents) / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0];
    var decimals = parts[1];

    function group(sep) {
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }

    var out;
    if (format.indexOf('amount_no_decimals_with_comma_separator') !== -1) {
      out = format.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, group('.'));
    } else if (format.indexOf('amount_with_comma_separator') !== -1) {
      out = format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, group('.') + ',' + decimals);
    } else if (format.indexOf('amount_no_decimals') !== -1) {
      out = format.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(','));
    } else {
      out = format.replace(/\{\{\s*amount\s*\}\}/g, group(',') + '.' + decimals);
    }
    return out.replace(/<[^>]*>/g, '').trim();
  }

  function updateCartChrome(cartData) {
    if (!cartData || typeof cartData.item_count !== 'number') return;

    // Header'daki sepet rozeti (her sayfada mevcut)
    document.querySelectorAll('[data-be-cart-count]').forEach(function (badge) {
      if (cartData.item_count > 0) {
        badge.textContent = String(cartData.item_count);
        badge.hidden = false;
      } else {
        badge.textContent = '';
        badge.hidden = true;
      }
    });

    var root = document.querySelector('cart-items.be-cart');
    if (!root) return;

    root.classList.toggle('is-empty', cartData.item_count === 0);

    var summaryCol = root.querySelector('.be-cart__summary-col');
    if (summaryCol) summaryCol.classList.toggle('is-empty', cartData.item_count === 0);

    // "3 ürün" başlık sayacı
    var countEl = root.querySelector('[data-be-cart-head-count]');
    if (countEl) {
      if (cartData.item_count > 0) {
        countEl.textContent = cartData.item_count + ' ürün';
        countEl.hidden = false;
      } else {
        countEl.textContent = '';
        countEl.hidden = true;
      }
    }

    // Ücretsiz kargo barı (eşik modunda; her zaman ücretsizde statik banner)
    var shell = root.querySelector('.be-cart__shell');
    var alwaysFree = shell && shell.getAttribute('data-be-always-free-shipping') === 'true';
    var shippingBlock = root.querySelector('[data-be-cart-shipping]');
    if (shippingBlock && !alwaysFree) {
      var thresholdTl = parseInt(
        shippingBlock.getAttribute('data-be-shipping-threshold') ||
          (shell && shell.getAttribute('data-be-shipping-threshold')) ||
          '0',
        10
      );
      if (thresholdTl > 0) {
        var thresholdCents = thresholdTl * 100;
        var subtotal = cartData.total_price || 0;
        var remaining = thresholdCents - subtotal;

        if (cartData.item_count === 0) {
          shippingBlock.hidden = true;
        } else {
          shippingBlock.hidden = false;

          var msgEl = shippingBlock.querySelector('[data-be-cart-shipping-msg]');
          if (msgEl) {
            if (remaining > 0) {
              msgEl.innerHTML = 'Ücretsiz kargo için <strong>' + formatMoney(remaining) + '</strong> daha ekleyin';
            } else {
              msgEl.innerHTML = '<strong>Tebrikler!</strong> Ücretsiz kargo kazandınız';
            }
          }

          var progressEl = shippingBlock.querySelector('[data-be-cart-shipping-progress]');
          if (progressEl) {
            var progress = thresholdCents > 0 ? Math.min(100, Math.round((subtotal * 100) / thresholdCents)) : 0;
            progressEl.style.width = progress + '%';
          }
        }
      } else {
        shippingBlock.hidden = true;
      }
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cartData) {
        updateCartChrome(event.cartData);
      }
    });
  }

  function showOutfitStatus(root, message, isError) {
    if (!root) return;
    var el = root.querySelector('[data-be-cart-outfit-status]');
    if (!el) return;
    el.hidden = !message;
    el.textContent = message || '';
    el.classList.toggle('is-error', !!isError);
  }

  function refreshCartAfterOutfitAdd() {
    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.onCartUpdate === 'function') {
      return cartItems.onCartUpdate().then(function () {
        return fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            updateCartChrome(cart);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'be-cart-outfit', cartData: cart });
            }
            // Footer (özet) de yenilensin
            var footer = document.getElementById('main-cart-footer');
            if (footer && footer.dataset.id) {
              return fetch(window.routes.cart_url + '?section_id=' + footer.dataset.id)
                .then(function (r) {
                  return r.text();
                })
                .then(function (text) {
                  var html = new DOMParser().parseFromString(text, 'text/html');
                  var src = html.getElementById('main-cart-footer');
                  if (src && footer) {
                    var srcContents = src.querySelector('.js-contents');
                    var dstContents = footer.querySelector('.js-contents');
                    if (srcContents && dstContents) dstContents.innerHTML = srcContents.innerHTML;
                    footer.classList.toggle('is-empty', cart.item_count === 0);
                  }
                })
                .catch(function () {});
            }
          });
      });
    }

    // Fallback: tam sayfa yenile
    window.location.reload();
    return Promise.resolve();
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-be-cart-outfit-add]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    var variantId = parseInt(btn.getAttribute('data-variant-id') || '', 10);
    if (!variantId) return;

    var outfitRoot = btn.closest('.be-cart-outfit');
    var title = btn.getAttribute('data-product-title') || '';
    btn.classList.add('is-loading');
    btn.disabled = true;
    showOutfitStatus(outfitRoot, 'Ekleniyor…', false);

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) {
            var msg =
              (data && (data.description || data.message)) ||
              'Sepete eklenemedi';
            throw new Error(msg);
          }
          return data;
        });
      })
      .then(function () {
        showOutfitStatus(outfitRoot, (title ? title + ' ' : '') + 'sepete eklendi ✓', false);
        return refreshCartAfterOutfitAdd();
      })
      .catch(function (err) {
        showOutfitStatus(outfitRoot, (err && err.message) || 'Sepete eklenemedi', true);
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  });
})();
